import { Col, Row } from '@design-system/components/grid/grid';
import { Typography } from '@design-system/components/typography/typography';
import { IconButton } from '@design-system/components/button/iconButton';
import { faArrowLeft } from '@fortawesome/pro-regular-svg-icons';
import { Link } from 'react-router';
import {
  Pill,
  PillProps,
} from '@client/new/pages/promotions/view/components/Pill';
import { PropsWithChildren } from 'react';

type BackHeaderProps = {
  title: string;
  subTitle?: string;
  backURL: string;
  pillTitle?: string;

  pillType?: PillProps['type'];
  pillColor?: PillProps['backgroundColor'];
};

export const BackHeader = (p: PropsWithChildren<BackHeaderProps>) => (
  <Row>
    <Col>
      <Row alignCenter gap="l">
        <Link to={p.backURL}>
          <IconButton
            style={{ backgroundColor: 'white', width: 40 }}
            variant="filled"
            size="medium"
            color="primaryTonal"
            icon={faArrowLeft}
          />
        </Link>
        <Row gap="l">
          <Col>
            <Typography variant="title" size="large">
              {p.title}
            </Typography>
          </Col>
          {p.pillTitle ? (
            <Col>
              <Pill
                backgroundColor={p.pillColor}
                content={p.pillTitle}
                maxWidth="max-content"
              />
            </Col>
          ) : null}
        </Row>
      </Row>
    </Col>
    <Col style={{ flex: '0 0 auto', width: 'auto' }}>
      {p.children ? p.children : null}
    </Col>
  </Row>
);
